// extracted by mini-css-extract-plugin
export default {"wrapper":"AppBar_wrapper__Tc4pf","section":"AppBar_section__6Cpfx","title":"AppBar_title__mtclV"};